(function() { module.exports = window["AFFWP"]["portal"]["alpineChart"]; }());